export class TranslationKeys {

	static sidebar_menu = "sidebar_menu";
  static profile_and_settings = "profile_and_settings";
  static logout = "logout";
  static logout_confirm_message = "logout_confirm_message";
  static register = "register";
  static sign_in = "sign_in";
  static continue = "continue";
  static is_currently_authenticated_remember_this_account = "is_currently_authenticated_remember_this_account";
  static forgot_password = "forgot_password";
  static email = "email";
  static password = "password";
  static password_visible = "password_visible";
  static password_hidden = "password_hidden";
  static confirm_password = "confirm_password";
  static continue_as_anonymous = "continue_as_anonymous";
  static log_in_with = "log_in_with";
  static home = "home";

  static button_translation_switch = "button_translation_switch";
  static button_disabled = "button_disabled";

  static by_continuing_you_agree_to_terms_and_conditions_and_privacy_policy = "by_continuing_you_agree_to_terms_and_conditions_and_privacy_policy";

  static cookie_policy_consent = "cookie_policy_consent";
  static cookie_policy_details = "cookie_policy_details";
  static cookie_policy_about = "cookie_policy_about";
  static cookie_policy_button_accept_all = "cookie_policy_button_accept_all";
  static cookie_policy_button_deny_all = "cookie_policy_button_deny_all";
  static cookie_policy_button_allow_selected = "cookie_policy_button_allow_selected";
  static cookie_policy_consent_date = "cookie_policy_consent_date";
  static cookie_policy_policy_date_updated = "cookie_policy_policy_date_updated";
  static cookie_policy_details_name = "cookie_policy_details_name";
  static cookie_policy_group_necessary = "cookie_policy_group_necessary";
  static cookie_policy_details_provider = "cookie_policy_details_provider";
  static cookie_policy_details_purpose = "cookie_policy_details_purpose";
  static cookie_policy_details_expiry = "cookie_policy_details_expiry";
  static cookie_policy_details_expiry_persistent = "cookie_policy_details_expiry_persistent";
  static cookie_policy_details_type = "cookie_policy_details_type";
  static cookie_policy_provider_we = "cookie_policy_provider_we";
  static cookies = "cookies";

}
